module.exports = __webpack_public_path__ + "fonts/roboto-thinitalic-webfont.woff2";